import { ReactNode, useEffect } from 'react';

import { useGetClientInfo } from './useGetClientInfo';
import { ClientInfoContext } from './clientInfoContext';
import { CheckIfUserHasPortalPrivilege } from '../../../common/client-status/interfaces';

interface Props {
  children: ReactNode;
  checkIfUserHasPortalPrivilege: CheckIfUserHasPortalPrivilege;
}

export const WithClientInfo = ({ children, checkIfUserHasPortalPrivilege }: Props) => {
  const { clientInfo, clientInfoLoading, clientInfoError, handleGetClientInfo } = useGetClientInfo();
  const getClientInfo = () => (checkIfUserHasPortalPrivilege('CLIENT_INFO') ? handleGetClientInfo() : undefined);

  useEffect(() => {
    getClientInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ClientInfoContext.Provider
      value={{
        getClientInfo,
        clientInfo,
        clientInfoLoading,
        clientInfoError
      }}
    >
      {children}
    </ClientInfoContext.Provider>
  );
};
